import React, { useState, useEffect } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import SelectResearch from '../components/SelectResearch';

const createOptions = (items = [], selected, defaultText) => {
	const options = items.map((item) => {
		return (
			<option
				key={item.name}
				value={item.name}
				selected={selected === item.name}
			>
				{item.name}
			</option>
		);
	});
	options.unshift(
		<option key="0" value="0" selected={selected === '0'}>
			{defaultText}
		</option>
	);
	return options;
};

const SectionCategorie = ({
	categories,
	categoria,
	sottocategoria,
	updateField,
}) => {
	const [categoriePrincipali, setCategorie] = useState([
		<option key="0" value="0" selected>
			Scegli una provincia
		</option>,
	]);
	const [sottocategorie, setSottoCategorie] = useState([
		<option key="0" value="0" selected>
			Scegli una città
		</option>,
	]);

	useEffect(() => {
		const categoriesToShow = [];
		const categoriesToExclude = ['Assicurazione', 'Senza Categoria'];

		categories.forEach(function (category) {
			if (!categoriesToExclude.includes(category.name)) {
				categoriesToShow.push(category);
			}
		});

		setCategorie(
			createOptions(categoriesToShow, categoria, 'Scegli una categoria')
		);
	}, [categories]);

	useEffect(() => {
		const fetchData = async () => {
			if (categoria === '0') {
				setSottoCategorie(
					createOptions([], '0', 'Scegli una sottocategoria')
				);
				return;
			}
			const resultSubcats = await axios(
				`${window.location.origin}/wp-json/telepass-v1/get_subcategorie?term_name=${categoria}`
			);
			setSottoCategorie(
				createOptions(
					resultSubcats.data.terms,
					sottocategoria,
					'Scegli una sottocategoria'
				)
			);
		};
		fetchData();
	}, [categoria]);
	return (
		<div className="section-categories has-border-bottom p-b-24">
			<p className="section-title has-text-weight-semibold m-b-16">
				Servizio
			</p>
			<div className="columns is-multiline">
				<div className="column is-half-tablet is-full-widescreen">
					<SelectResearch
						items={categoriePrincipali}
						name="categoria"
						updateField={updateField}
					/>
				</div>
				<div className="column is-half-tablet is-full-widescreen">
					<SelectResearch
						items={sottocategorie}
						name="sottocategoria"
						updateField={updateField}
						disabled={categoria === '0'}
					/>
				</div>
			</div>
		</div>
	);
};

SectionCategorie.propTypes = {
	categories: PropTypes.instanceOf(Array).isRequired,
	categoria: PropTypes.instanceOf(String).isRequired,
	sottocategoria: PropTypes.instanceOf(String).isRequired,
	updateField: PropTypes.instanceOf(Function).isRequired,
};

export default SectionCategorie;
